import styled, { css } from 'styled-components'
import { themeGet } from '@styled-system/theme-get'

import { Flex } from 'Components/UI'

export const Container = styled(Flex)`
  flex-direction: row;
  width: 100%;
  justify-content: center;
`

const starsHolderCanHoverCss = ({ canHover }) =>
  canHover &&
  css`
    cursor: pointer;
    :hover {
      color: ${themeGet('colors.primary')};
    }
  `

const shouldForwardProp = prop => {
  return !['canHover', 'filled'].includes(String(prop))
}

export const StarsHolder = styled(Flex).withConfig({
  shouldForwardProp,
})`
  font-size: 32px;

  color: ${themeGet('colors.softPeach')};

  ${starsHolderCanHoverCss}
`

const starHolderFilledCss = ({ filled }) =>
  filled &&
  css`
    color: ${themeGet('colors.primary')};
  `

const starHolderCanHoverCss = ({ canHover }) =>
  canHover &&
  css`
    :hover {
      color: ${themeGet('colors.primary')};
    }
  `

export const StarHolder = styled.div.withConfig({
  shouldForwardProp,
})`
  ${starHolderCanHoverCss}
  ${starHolderFilledCss}
`
